
import { useTranslation } from "react-i18next"
import { Button } from "@/components/ui/button"
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu"
import { GlobeIcon } from "lucide-react"

export function LanguageSwitcher() {
  const { t, i18n } = useTranslation()

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng)
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
          <Button variant="outline" size="sm" className="w-auto" onClick={e => { e.preventDefault(); e.stopPropagation(); }}>
          <GlobeIcon className="h-5 w-5" />
          <span className="sr-only">{t("header.language")}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => changeLanguage("en")}>{t("header.english")}</DropdownMenuItem>
        <DropdownMenuItem onClick={() => changeLanguage("sq")}>{t("header.albanian")}</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
